import { Order, OrderReturnStatus, OrderStatus, OrderType } from '../../../clients/quipli-service/order/order';
import { useEffect, useState } from 'react';
import { ApproveOrder } from './approve-order';
import { toast } from '../../../util/toasts';
import { useOrderApiV1 } from '../../../clients/quipli-service/order/order-api-v1';
import { Button } from '../../../components/form/button';
import { OnRentOrder } from './on-rent-order';

export const StatusTransitionButtons = ({ orderId }: { orderId: number }) => {
  const { getOrderById, getOrderMessage } = useOrderApiV1();
  const [order, setOrder] = useState<Order>();
  const [activeStatusModal, setActiveStatusModal] = useState<'approve' | 'onRent' | undefined>();

  useEffect(() => {
    getOrderById(orderId)
      .then(setOrder)
      .catch((err) => toast(err.message, 'error'));
    getOrderMessage(orderId).then((m) => {
      if (m) {
        toast(m, 'error');
      }
    });
  }, []);

  return (
    <>
      {order && (
        <div className="order-status-transitions">
          {order.status === OrderStatus.Requested && (
            <Button className="button button-primary" onClick={() => setActiveStatusModal('approve')}>
              Approve Order
            </Button>
          )}
          {order.status === OrderStatus.Approved &&
            order.products.some(
              (p) => p.type === OrderType.Rental && (!p.status || p.status === OrderReturnStatus.NotStarted),
            ) && (
              <Button className="button button-primary" onClick={() => setActiveStatusModal('onRent')}>
                On Rent
              </Button>
            )}
          {activeStatusModal === 'approve' && (
            <ApproveOrder
              orderId={order.id}
              onCancel={() => setActiveStatusModal(undefined)}
              onComplete={() => {
                setActiveStatusModal(undefined);
                window.location.reload();
              }}
            />
          )}
          {activeStatusModal === 'onRent' && (
            <OnRentOrder
              orderId={order.id}
              onCancel={() => setActiveStatusModal(undefined)}
              onComplete={() => {
                setActiveStatusModal(undefined);
                window.location.reload();
              }}
            />
          )}
        </div>
      )}{' '}
    </>
  );
};
